import { Typography } from '@mui/material';
import { Popup } from '@elements';
/**
 * DefaultPopup component.
 *
 * @author Christina Kashevar
 * @function DefaultPopup
 * @category components
 * @param {PopupProps} popup props.
 * @return {FC} popup component.
 */

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var DefaultPopup = function DefaultPopup(_ref) {
  var _popUp$data;

  var popUp = _ref.popUp;
  return /*#__PURE__*/_jsxs(Popup, {
    popUp: popUp,
    maxWidth: popUp === null || popUp === void 0 ? void 0 : (_popUp$data = popUp.data) === null || _popUp$data === void 0 ? void 0 : _popUp$data.maxWidth,
    children: [/*#__PURE__*/_jsx(Popup.Title, {
      children: popUp && popUp.data && popUp.data.header
    }), popUp && popUp.data && popUp.data.body && /*#__PURE__*/_jsx(Popup.Content, {
      children: /*#__PURE__*/_jsx(Typography, {
        color: "raven",
        textAlign: "center",
        variant: "body2",
        sx: {
          wordBreak: 'break-word'
        },
        children: popUp.data.body
      })
    })]
  });
};

export { DefaultPopup };